import React from 'react';

import { ia } from 'lib/helpers/utility';

import Button from 'components/shared/Buttons/Button';

const Footer = ({
  mode,
  setMode = () => {},
  hideQuoteModal = () => {},
  finalLoading,
  formik,
  checkQuote = () => {},
  createQuoteHandler = () => {}
}) => {
  return (
    <>
      <div className="flex w-full items-center justify-between">
        {mode.readonly && !mode.created ? (
          <Button
            outlined
            transparent
            text="Back"
            color="neutral"
            onClick={() => setMode((prev) => ({ ...prev, readonly: false }))}
          />
        ) : (
          <Button
            data-qa="close-btn"
            outlined
            transparent
            color="neutral"
            onClick={hideQuoteModal}
            text={mode.created ? 'Close' : 'Cancel'}
          />
        )}

        {!mode.readonly && !mode.created && (
          <Button
            text="Continue"
            loadingIcon={finalLoading}
            onClick={checkQuote}
            data-qa="continue-from-list-to-quote"
            disabled={
              !ia(formik?.values?.services) &&
              !ia(formik?.values?.packages) &&
              !ia(formik?.values?.products) &&
              true
            }
          />
        )}

        {mode.readonly && !mode.created && (
          <Button
            text="Create Quote"
            loadingIcon={finalLoading}
            onClick={createQuoteHandler}
            data-qa="create-quote"
          />
        )}
      </div>
    </>
  );
};

export default Footer;
